import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactModal  from 'react-modal';
import { voteLike } from '../helpers/Utils';
import { useContext } from 'react';
import {useConfig} from "../helpers/useConfig";
import {useCurrentUser} from "../helpers/UserContext";
import { c_or_f } from '../helpers/Utils';
import Btn from './Button';
const ColdMeter = (props) => {
  var resultCMVote;
  const { t } = useTranslation();
  const {configData, setConfig} = useConfig();
  const callVoteLike = async () => {
    var gender = localStorage.getItem('gender');
    if (gender == null)
        gender = '';
    const json = await voteLike(cm_value, gender);
    console.log (json.result.message);
    setCMResult(json.result.message);
    return json.result.message;
 }
  const Vote_cm_like = (cm_value) => {
    console.log(cm_value);
    console.assert(cm_value!="");
    if (cm_value === "")
        return;
    let _data = {
        SendSurveyButton: 1,
        json_res: 1,
        survey: cm_value, 
        survey_id:2
    }
    callVoteLike();
    setIsCMResultOpen(true);
    
  };
  const vote_cm_dislike = (isSun) => {
    console.log('vote_cm_dislike isSun=', isSun);
    setIsSun(isSun);
    setPopupIsOpen(true);
  };
  const [output, setColdMeter] = useState([]);
  const [output_sun, setColdMeterSun] = useState([]);
  const [asterisk, setAsterisk] = useState("");
  const [asterisk_sun, setAsteriskSun] = useState("");
  const [clothColdMeter, setClothColdMeter] = useState([]);
  const [clothColdMeterSun, setClothColdMeterSun] = useState([]);
  const [coldTitle, setColdTitle] = useState([]);
  const [coldTitleSun, setColdTitleSun] = useState([]);
  const [heatindex, setHeatIndex] = useState([]);
  const [isOpen, setPopupIsOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [isSun, setIsSun] = useState(false);
  const [isCMResultOpen, setIsCMResultOpen] = useState(false);
  const [cm_value, setCMvalue] = useState(false);
  const [cm_value_result, setCMResult] = useState(false);
  const [cm_value_sun, setCMSunvalue] = useState(false);
  const {currentUser, userIsLoading } = useCurrentUser();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const customStyles = {
    content: {
      width:(screenWidth > 800 ) ? '420px' :'100%',
      padding: '10px',
      top: (screenWidth > 800 ) ? '20px' :'10px',
      left: (screenWidth > 800 ) ? screenWidth/2 :'0',
      right: 'auto',
      direction: (configData.lang == 1) ? 'rtl' : '',
      bottom: 'auto',
      position: 'absolute',
    },
  };
  const setIsOpen = ({isOpen}) => {
    setPopupIsOpen(isOpen);
  }
    useEffect(() =>{
        if (userIsLoading) return;
        var opts = {
          headers: {
           
          }
        }
        const handleResize = () => {
              setScreenWidth(window.innerWidth);
              //alert(window.innerWidth);
  
          };
        const fetchJson = async () => {
          var url = `https://v2013.02ws.co.il/coldmeter_service.php?lang=${props.lang}&json=1&cloth_type=e`;
          if (currentUser) {
            url = url +  '&email=' + currentUser.email;
          } 
          console.log('currentUser in coldmeter: ', currentUser);
          console.log('fetch coldmeter: ', url);
          const response = await fetch(url, opts);
          const json = await response.json();
          console.log('json response: ', json);
          const clothtitle = json.coldmeter.clothtitle;
          const clothimage = json.coldmeter.cloth_name;
          const asterisk = json.coldmeter.asterisk;
          const coldmeter_title = json.coldmeter.current_feeling;
          const clothtitle_sun = json.coldmeter_sun?.clothtitle;
          const clothimage_sun = json.coldmeter_sun?.cloth_name;
          const asterisk_sun = json.coldmeter_sun?.asterisk;
          const coldmeter_title_sun = json.coldmeter_sun?.current_feeling;
          const heatindex = json.coldmeter.heatindex;
          const cm_value = json.coldmeter.current_value;
          const cm_value_sun = json.coldmeter_sun?.current_value;
          
          var output = `${clothtitle}`;
          const output_sun = `${clothtitle_sun}`;
          setColdMeter(output);
          setColdMeterSun(output_sun);
          setClothColdMeter(clothimage);
          setClothColdMeterSun(clothimage_sun);
          setColdTitle(coldmeter_title);
          setColdTitleSun(coldmeter_title_sun);
          setAsterisk(asterisk);
          setAsteriskSun(asterisk_sun);
          setHeatIndex(heatindex);
          console.log ("setCMvalue:" + cm_value);
          setCMvalue(cm_value);
          console.log ("setCMSunvalue:" + cm_value_sun);
          setCMSunvalue(cm_value_sun);
        };
        fetchJson();
        handleResize();
        window.addEventListener('resize', handleResize);
        const timer = setInterval(() => {
          if (userIsLoading) return;
          fetchJson();
        }, 60000);
      }, [userIsLoading, currentUser])
    
    return (
      
        <div  id="coldmeter" className="">
        <div id="heatindex">
            {heatindex}
        </div>
        <div id="itfeels_title"></div>
        <div id="shadow_sun_wrapper">
        {(props.showShadow) ?          
        <div className="shade" >
        
        <div className="inline">
         <div className="feelsLike">
           {t("IT_FEELS")} {' '}
          {c_or_f(props.shadowtemp, configData.tempUnit)}° {(props.issun === 'true') ? t("SHADE") : ''}
         </div>
        <a href="#" rel="external" className="info cboxElement" onClick={(e) => {e.stopPropagation();e.preventDefault();}}> 
        <span id="current_feeling_link">
            <img src={`https://v2013.02ws.co.il/images/clothes/${clothColdMeter}`} height="80" alt="cold meter" onLoad={() => setLoaded(true)} style={{
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.4s ease",
        }} /><br/>{coldTitle}<br/>
        </span>
        <span className="info">{output}</span>
         </a>
         {asterisk.trim() != "" ? <a href="javascript:void(0)" id="asterisk" className="info" >&#x002A;<span className="info">{asterisk}</span></a> : ''}
         
        <div className="cm_dislike" onClick={() => vote_cm_dislike(false)}> </div>
        <div className="cm_like" onClick={() => Vote_cm_like(cm_value)}></div>
        <div id="cm_shadow_result" ><div id="cm_shadow_result_msg"></div></div>
        
        </div> 
        
        </div> : ''
        }
         {(props.issun === 'true')&&(props.showSun) ? 
          <div className="sun" >
          <div className="inline">
          <div className="feelsLike">
             {t("IT_FEELS")} {' '}
            {c_or_f(props.suntemp, configData.tempUnit)}° {t("IN_THE_SUN")}
          </div>
          <a href="#" rel="external" className="info cboxElement" onClick={(e) => {e.stopPropagation();e.preventDefault();}}>  
          <span id="current_feeling_link">
            <img src={`https://v2013.02ws.co.il/images/clothes/${clothColdMeterSun}`} height="80" alt="cold meter" onLoad={() => setLoaded(true)} style={{
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.4s ease",
        }} /><br/>{coldTitleSun}<br/>
          </span>
          <span className="info">{output_sun}</span>
          </a>

          
          <div className="cm_dislike" onClick={() => vote_cm_dislike(true)}></div>
          <div className="cm_like" onClick={() => Vote_cm_like(cm_value_sun)}></div>
          <div id="cm_sun_result" ><div id="cm_sun_result_msg"></div></div>
          </div>
          </div> : ''
        }
        </div>
        
        
        <ReactModal
        className=""
        isOpen={isOpen}
        contentLabel="Example Modal"
        style={customStyles}
        onRequestClose={() => setIsOpen(false)}
      >
         <Btn btnOnClick={() => setIsOpen(false)} btnTitleText={""}  img={"X"} cssClasses={(props.lang == 1? 'float-start' : 'float-end')}>
                 
          </Btn>
         <iframe src={"https://v2013.02ws.co.il/small/?section=survey.php&survey_id=2&is_sun=" + isSun}  sandbox='allow-scripts allow-modal allow-forms allow-same-origin' scrolling="yes" loading='eager' title="iframePopup"  ></iframe>
      </ReactModal>

      <ReactModal
        className=""
        isOpen={isCMResultOpen}
        ariaHideApp={false}
        contentLabel="מדד הקור"
        style={customStyles}
        onRequestClose={() => setIsCMResultOpen(false)}
      >
        <Btn btnOnClick={() => setIsCMResultOpen(false)} btnTitleText={""}  img={"X"} cssClasses={(props.lang == 1? 'float-start' : 'float-end')}>
                 
                 </Btn>
        <h4>הצבעה למדד הקור</h4>
         {cm_value_result}
      </ReactModal>
       
         
        </div>
        
    );
}

export default ColdMeter; 